import useUnsuspendedTranslation from "../hooks/useUnsuspendedTranslation";
import Error from "./Error";

const ErrorDisplay = ({ error }) => {
  const { t } = useUnsuspendedTranslation();
  const isNubError = (error?.response?.config?.url || '').match('/nubs.json')
  
  console.debug('ERROR DISPLAY', error)

  switch (error?.response?.status) {
    case 403:
      return (
        <Error
          title={t("Not Authorized")}
          message={t("You need to be a game administrator in order to take that action.")}
        />
      );
    case 404:
      return (
        <Error
          title={t("Not Found")}
          message={t("The resource you are looking for does not exist.")}
        />
      );
    case 406:
    case 500:
    case 501:
    case 502:
    case 503:
      const description = {
        406: t(`<strong>Error 406</strong>: <em>The browser has requested a response using Accept- headers that the server cannot fulfill.</em>`),
        500: t(`<strong>Error 500</strong>: <em>The server encountered an unexpected condition that prevented it from fulfilling the request.</em>`),
        501: t(`<strong>Error 501</strong>: <em>The server does not support the functionality required to fulfill the request.</em>`),
        502: 
            // show specific error for AI nubs creation
            isNubError
                ? t(`<em>You're only able to create ${process.env.REACT_APP_MAX_AI_PER_HOUR} AI generated photos in an hour. Please wait and try again later.</em>`)  
                : t(`<strong>Error 502</strong>: <em>The server, while acting as a gateway or proxy, received an invalid response from the upstream server.</em>`),
        503: t(`<strong>Error 503</strong>: <em>The server is not ready to handle the request.</em>`),
      }
      const title = {
        501: t(`Server error`),
        502: isNubError ? t(`Limit Reached`) : t(`Server error`),
        503: t(`Server error`),
      }
      return (
        <Error
          title={title[error?.response?.status] || t("Lost connection")}
          message={(
            <>
                {
                error?.response?.status === 500 
                    ? <p className="mb-4">{t(`There has been a problem connecting with our platform. Please click retry to try again.`)}</p>
                    : null
                }
                <p dangerouslySetInnerHTML={{__html: description[error?.response?.status]}} />
            </>
          )}
        />
      );
    default:
      return (
        <Error
          title={t("An error occurred.")}
          message={t("An unexpected error occurred and we <br/>couldn't load this page. Please try again later <br/>or contact Cityhunt support.")}
        />
      );
  }
};

export default ErrorDisplay;
